import { render } from "./PromotionProductComponent.vue?vue&type=template&id=75ba301f"
import script from "./PromotionProductComponent.vue?vue&type=script&lang=js"
export * from "./PromotionProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/PromotionProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75ba301f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75ba301f', __exports__)) {
    api.reload('75ba301f', __exports__)
  }
  
  module.hot.accept("./PromotionProductComponent.vue?vue&type=template&id=75ba301f", () => {
    api.rerender('75ba301f', render)
  })

}


export default __exports__